import React from 'react';
import {
  ArticleContent,
  ArticleImage,
  ArticleMainImage,
  ArticleTitle,
  ContentAndSidebar,
  DecoratedQuote,
  Divider,
  MainCategory as MainCategoryComponent,
  PostMainContent,
  RecommendationsAdvertisement,
  ShareButton,
  Slideshow as SlideshowComponent,
  Sponsor,
} from 'mm-ui-components';
import { DefaultHeaderPostSidebarConnected } from '../../components/connectedComponents/PostSidebarConnected';
import { createDefaultBlocksWidths } from '../postPage.util';
import { ArticleComponentDataProps } from '../utils/articleComponent.utils';

const blocksWithMultipleOptions = {
  divider: Divider,
  quote: DecoratedQuote,
  image: ArticleImage,
};
const defaultBlocksWidths = createDefaultBlocksWidths();

export const BaliArticleComponent: React.FunctionComponent<ArticleComponentDataProps> = props => {
  const {
    mainCategory,
    title,
    by,
    updatedAtDateFormatted,
    updatedAtTimeAndDateFormatted,
    authors,
    shareConfig,
    canonical,
    cover,
    siteName,
    templateName,
    sponsor,
    slideshow,
    body,
    sideBar1Id,
    sideBar2Id,
    showRecommendationsAdvertisement,
    revcontentWidgetID,
  } = props;
  return (
    <ContentAndSidebar>
      <PostMainContent>
        <header>
          {mainCategory ? (
            <MainCategoryComponent
              {...mainCategory}
              marginFactor={{
                largeMarginFactor: 0,
                mediumMarginFactor: 0,
                smallMarginFactor: 1,
              }}
            />
          ) : null}
          <ArticleTitle
            title={title}
            by={by}
            updatedAtDateFormatted={updatedAtDateFormatted}
            updatedAtTimeAndDateFormatted={updatedAtTimeAndDateFormatted}
            authors={authors}
          >
            <ShareButton shareConfig={shareConfig} canonical={canonical} />
          </ArticleTitle>
          <ArticleMainImage
            {...cover}
            siteName={siteName}
            templateName={templateName}
            defaultBlocksWidths={defaultBlocksWidths}
          />
        </header>
        {sponsor ? <Sponsor {...sponsor} /> : null}
        <SlideshowComponent {...slideshow} blockWidths={defaultBlocksWidths}>
          <ArticleContent
            blocksWithMultipleOptions={blocksWithMultipleOptions}
            body={body}
            templateName={templateName}
            siteName={siteName}
            defaultBlocksWidths={defaultBlocksWidths}
          />
        </SlideshowComponent>
      </PostMainContent>
      <DefaultHeaderPostSidebarConnected adId1={sideBar1Id} adId2={sideBar2Id} />
      {showRecommendationsAdvertisement
        ? <RecommendationsAdvertisement revcontentWidgetID={revcontentWidgetID} /> : null}
    </ContentAndSidebar>
  );
};
